import ErrorDisplay from "../errorDisplay";

import './style.scss';

let idx = 0;

const FormCheckbox = (props) => {
  const {
    name,
    id,
    label,
    value,
    checked,
    changeAction,
    onKeyDown,
    errors,
    disabled,
    focusOnError
  } = props;

  const idValue = id || label || name;
  const hasError = Boolean(errors?.length);
  const errorId = 'error-' + idx++;

  return (
    <div className='form-input'>
      <label htmlFor={idValue}>{label || name || id}</label>
      <input
        className={hasError ? 'error input-checkbox' : 'input-checkbox'}
        id={idValue}
        type='checkbox'
        name={name}
        value={value}
        checked={!!checked}
        disabled={disabled}
        aria-describedby={hasError ? errorId : null}
        onChange={(e) => {
            changeAction(!!e.target.checked);
          }
        }
        onKeyDown={onKeyDown || null}
      />
      { hasError && <ErrorDisplay shouldFocus={focusOnError} errors={errors} id={errorId}/> }
    </div>
  )
};

export default FormCheckbox;
